module.exports = __webpack_public_path__ + "media/question8_en.78ca8cf7.mp3";